import gql from 'graphql-tag';

export const SETTINGS_CREATE = gql`
  mutation ($scope: String!, $scopeId: ID, $data: JSON = "{}") {
    settingsCreate(scope: $scope, scope_id: $scopeId, data: $data) {
      id
      scope
      scope_id
      data_filled
      data_scoped
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/settings/create.js